module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "slider"
  }, [_c('ul', {
    staticClass: "slides"
  }, [_c('li', [_c('img', {
    attrs: {
      "src": require("../../img/galeriaFotos/048.jpg")
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../../img/galeriaFotos/054-1.jpg")
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../../img/galeriaFotos/041.jpg")
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12 m12 l12"
  }, [_c('div', {
    staticClass: "card z-depth-2 hoverable"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("O Hotel")]), _vm._v(" "), _c('p', [_vm._v("O "), _c('b', [_vm._v("Resplendor Center Hotel")]), _vm._v(" está localizado no coração da\n                                cidade de Resplendor MG, próximo dos centros comerciais e\n                                restaurantes. Proporcionando um lugar para trabalhar e relaxar!\n                            ")])])])])])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-49487d93", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49487d93"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/hotel/hotel.vue
// module id = 84
// module chunks = 0